import ProjectRow from "../ui/ProjectRow";
import StaggerContainer from "../motion/StaggerContainer";
import PretextReveal from "../motion/PretextReveal";

const projects = [
  { id: "001", industry: "LEGAL", name: "Law Firm CRM for 40-Advocate Practice", metric: "60%", metricLabel: "faster client intake", year: "2024", slug: "/work/law-firm-crm" },
  { id: "002", industry: "REAL ESTATE", name: "AI Lead Qualification for Property Broker", metric: "3×", metricLabel: "more site visits booked", year: "2024", slug: "/work/real-estate-ai" },
  { id: "003", industry: "AI AUTOMATION", name: "AI Call Centre for Insurance Follow-up", metric: "5,000", metricLabel: "calls/month, zero agents", year: "2025", slug: "/work/ai-call-centre" },
  { id: "004", industry: "E-COMMERCE", name: "D2C Shopify Store with AI Recommendations", metric: "40%", metricLabel: "increase in order value", year: "2025", slug: "/work/ecommerce" },
];

export default function FeaturedWork() {
  return (
    <section style={{ background: "#050505", padding: "120px 40px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 60, gap: 24, flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 16, flexWrap: "wrap" }}>
              <PretextReveal
                mode="slide"
                as="div"
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 300,
                  fontSize: "clamp(40px, 5vw, 64px)",
                  color: "#F8F4EC",
                  lineHeight: 0.9,
                }}
                delay={0}
              >
                Selected
              </PretextReveal>
              <PretextReveal
                mode="slide"
                as="div"
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: "clamp(40px, 5vw, 64px)",
                  color: "#D4A843",
                  lineHeight: 0.9,
                }}
                delay={0.12}
              >
                Work.
              </PretextReveal>
            </div>
            <a
              href="/work"
              className="nav-link-draw"
              style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 14, color: "#D4A843" }}
            >
              View All Projects →
            </a>
          </div>

        <StaggerContainer stagger={0.1} style={{ borderTop: "0.5px solid rgba(212,168,67,0.15)" }}>
          {projects.map((project) => (
            <ProjectRow key={project.id} {...project} />
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
